// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";

/**
 * Convert UTC Date to local timezone for picker display
 */
export function getLocalTimeForPicker(utcDate: Date, workplaceTimezone: string): Date {
  return utcToZonedTime(utcDate, workplaceTimezone);
}

/**
 * Convert local picker time back to UTC for storage/API
 */
export function getUtcTimeFromPicker(localDate: Date, workplaceTimezone: string): Date {
  return zonedTimeToUtc(localDate, workplaceTimezone);
}
